module.exports = __webpack_public_path__ + "img/yesOrNoEle.30baecd9.svg";